import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const DeleteButtonWrapper = styled('div')`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0%, -50%);
  display: none;
  cursor: pointer;
`;

const DeleteButton = styled(Svg)`
  width: 12px;
`;

const DeletedIcon = styled(Svg)`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0%, -50%);
  width: 16px;
`;

export default {
  DeleteButtonWrapper,
  DeleteButton,
  DeletedIcon,
};
